import { gql, DocumentNode } from "@apollo/client";

export const FIELD_FRAGMENT: DocumentNode = gql`
  fragment fieldFragment on FieldInput {
    display_name
    field_name
    default_string_value
    field_input_type
    field_input_size
    required
    hidden
  }
`;

/** Shared node shape for both datasource definitions and threat intelligence definitions. */
export const DATASOURCE_DEFINITION_NODE_FRAGMENT: DocumentNode = gql`
  ${FIELD_FRAGMENT}
  fragment datasourceDefinitionNodeFragment on DatasourceDefinition {
    id
    name
    source_display_name {
      source_name
    }
    grouped_tags @include(if: $with_tags)
    last_received_finding @include(if: $with_last_received)
    instructions
    status
    category
    required_fields
    secret_configuration
    enable_check_connection
    enable_last_collected_threshold
    enable_last_reported_threshold
    default_last_collected_threshold
    default_last_reported_threshold
    is_rapable
    sections {
      name
      rows {
        fields {
          ...fieldFragment
          label_right
          min_value
          max_value
          tooltip
          is_multi
          options {
            values {
              id
              name
            }
            switch_cases {
              label
              name
              value
              rows {
                fields {
                  ...fieldFragment
                  tooltip
                  options {
                    values {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/** Shared node shape for datasources fast info (regular and threat intel). */
export const DATASOURCES_FAST_INFO_NODE_FRAGMENT: DocumentNode = gql`
  fragment datasourcesFastInfoNodeFragment on Datasource {
    id
    friendly_name
    required_fields_value
    secret_configuration_value
    enabled
    name
    rap_instance_id
    datasource_definition {
      id
      name
      source_display_name {
        source_name
      }
    }
  }
`;

/** Shared node shape for datasources slow info (regular and threat intel). */
export const DATASOURCES_SLOW_INFO_NODE_FRAGMENT: DocumentNode = gql`
  fragment datasourcesSlowInfoNodeFragment on Datasource {
    id
    name
    last_collection_time @include(if: $with_collection_start_time)
    collection_state @include(if: $with_collection_state)
    check_connection_status
    cron
    days_not_seen_to_declare_fixed
    last_collected_threshold
    last_reported_threshold
    enable_last_collected_threshold
    enable_last_reported_threshold
    datasource_definition {
      id
      name
    }
  }
`;
